module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("AlarmGroupError", "Set up insurance company and alarm central?") ))==null?'':__t)+
'</legend><p class="error">'+
((__t=( i18n.tc("AlarmGroupError", "You're not able to select an insurance company for this device. Make sure the GPS antenna and/or backup battery is connected, and re-test the device.") ))==null?'':__t)+
'</p></fieldset><fieldset class="button-wrap"><button data-click="group-error-cancel">'+
((__t=( i18n.tc("AlarmGroupError", "Cancel") ))==null?'':__t)+
'</button> <button class="primary" data-click="group-error-retest">'+
((__t=( i18n.tc("AlarmGroupError", "Retest") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
